import * as types from "../../actions/ActionTypes";

const initialState = {
    loading: false,
    data: null,
    error: null,
};

const followBusinessReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.FOLLOW_BUSINESS_START:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case types.FOLLOW_BUSINESS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case types.FOLLOW_BUSINESS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default followBusinessReducer;
